<template>
<div class="news-content-wrapper">
    <div id="newsBanner" class="banner-wrapper">
        <a href="javascript:void(0)" @click="login" class="item">
            <img src="@/assets/banner-1.jpg" alt="">
        </a>
        <a href="javascript:void(0)" @click="ocacLogin" class="item">
            <img src="@/assets/banner-2.jpg" alt="">
        </a>
        <a href="javascript:void(0)" @click="tracking" class="item">
            <img src="@/assets/banner-3.jpg" alt="">
        </a>
    </div>
    <div class="news-section">
        <div class="news-title">
            <img src="@/assets/Group 275@2x.png" alt="">
            公告資訊
        </div>
        <ul class="news-list">
            <li v-for="i in 1" :key="i">
                <a href="#/news-form" class="title">「倉儲服務網站」上線服務公告</a>
                <span class="date">2021/6/20</span>
            </li>
        </ul>
    </div>
    <div class="pagination-wrapper">
        <button type="button" class="btn">&lt;</button>
        <button type="button" class="btn">1</button>
        <button type="button" class="btn">&gt;</button>
    </div>
</div>
</template>

<script>
export default {
    mounted() {

        setTimeout(() => {
            $('#newsBanner').slick({
                arrow: false,
                dots: true,
                autoplaySpeed: 3500,
                autoplay: true,
                fade: true,
            });
        }, 150);
        /* eslint-disable */
    },
    methods: {
        //登入
        login() {
            this.$router.push("login-form");
        },
        //訂單查詢
        tracking() {
            this.$router.push("tracking-form");
        },
        //僑委會登入
        ocacLogin() {
            this.$router.push("login-ocac");
        }
    }

};
</script>

<style lang="scss">
@import url('//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css');
@import url('//cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick-theme.css');

.slick-dots {
    bottom: 1em;

    li {
        button:before {
            color: #fff;
        }

        &.slick-active button:before {
            color: #fff;
        }
    }
}
</style>
